import { render, staticRenderFns } from "./ChangeLang.vue?vue&type=template&id=5edfe6f0"
import script from "./ChangeLang.vue?vue&type=script&lang=ts"
export * from "./ChangeLang.vue?vue&type=script&lang=ts"
import style0 from "./ChangeLang.vue?vue&type=style&index=0&id=5edfe6f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports